<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>목록 대상
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>단체</th>
              <td>
                <div class="inline-flex">
                <select v-model="query.branchCd" v-focus>
                  <option value="">-단체 선택-</option>
                  <option v-for="item in branchTypeList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                </select>
               <select v-model="query.positionCd" :disabled="!query.branchCd || query.branchCd === 'Z'">
                  <option value="">-직책 선택-</option>
                  <option v-for="item in positionList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                </select>
                <input type="text" class="w100" disabled v-model="searchedBranchName">
                <button @click="() => {this.isShowBranchModal = true}" :disabled="!query.branchCd || query.branchCd !== 'Z'">
                  <md-icon :disabled="!query.branchCd || query.branchCd !== 'Z'">search</md-icon>
                </button>
                </div>
              </td>
              <th rowspan="2">SQL직접입력</th>
              <td rowspan="2">
                <textarea class="h100" v-model="query.strSql" placeholder = "AND M1.class_cd = '0140' [M1 : tb_member1, M2 : tb_member2]"></textarea>
              </td>
            </tr>
            <tr>
              <th>교우직위</th>
              <td>
                <select v-model="query.levelCd">
                  <option value="">교우직위 선택</option>
                  <option v-for="item in levelCdList" :key="item.code" :value="item.code" :label="item.codeNm"></option>
                </select>
              </td>
<!--
              <th>임원직위</th>
              <td>
              	<select v-model="query.memberorgGb">
                  <option value="">직위 선택</option>
                  <option v-for="item in levelCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                  </option>
              </select>
              </td>
-->
            </tr>
<!--            <tr>
              <th>SQL직접입력</th>
              <td colspan="5">
                <textarea class="h180" v-model="query.strSql"
                          placeholder = "M2.level_nm = (select CODE_NM from tb_cmm_code_l where CODE_GRP_ID ='LEVEL_CD' and CODE_CD = '01')"
                ></textarea>
              </td>
            </tr>-->
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <grid ref="executivesGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>
        </md-card-content>
      </md-card>
    </div>

    <business-group-search-pop-comp :is-show.sync="isShowBranchModal" :branch-gb="query.branchCd" @returnResult="onClickModalBranch"></business-group-search-pop-comp>

  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import BusinessGroupSearchPopComp from "@/pages/Common/BusinessGroupSearchPopComp";

export default {
  components: {
    BusinessGroupSearchPopComp,
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  watch: {
    'query.branchCd' : function(){
        if(this.query.branchCd){
          this.searchedBranchName = "";
          this.query.branchId = "";
          this.query.positionCd = "";
          this.query.levelCd = "";
          return;
        }
    },
    'query.levelCd' : function(){
      if(this.query.levelCd){
        this.searchedBranchName = "";
        this.query.branchId = "";
        this.query.positionCd = "";
        this.query.branchCd = "";
        return;
      }
    }
  },

  created() {
    this.queryLevelCdTypes();
    this.queryBranchTypes();
    this.queryPositionTypes();
    this.initGrid();
  },

  data() {
    return {
      levelCdList: [],
      branchTypeList: [],
      branchList: [],
      positionList: [],
      isShowBranchModal: false,
      searchedBranchName: "",

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      query: {
        levelCd: "",
        branchCd: "",
        branchId: "",
        strSql: "",
        positionCd: ""
      },
    }
  },

  methods: {
    /**
     * 임원 레벨코드 - 공통코드 조회 세팅
     */
    queryLevelCdTypes() {
      kuaaFnc.fncOrgLevelList(null,res => {
        this.levelCdList = res.data.data.contents;
      });
    },

    /**
     * branch - 공통코드 조회 세팅
     */
    queryBranchTypes() {
      kuaaFnc.fncBranchTypes(null,res => {
        this.branchTypeList = res.data.data.contents;
      });
    },

    queryPositionTypes() {
      kuaaFnc.fncPositionCodes(null,res => {
        this.positionList = res.data.data.contents;
      });
    },

    /**
     * 검색 실행
     */
    searchQuery() {
      this.doSearch();
    },

    /**
     * 검색조건 초기화
     */
    clearQuery() {
      this.query = {
        levelCd: "",
        branchCd: "",
        branchId: "",
        strSql: "",
      };
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    doSearch() {
      this.$refs.executivesGrid.invoke("readData", 1, this.query);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_LABEL_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo', width:90, align:"center", sortable: true},
          {header: '교우명', name: 'memberHnm', width:100, sortable: true},
          {header: '교우직위', name: 'levelNmExcel', width:100, sortable: true},
          {header: '학번', name: 'hakbun', width:90, align:"center", sortable: true},
          {header: '생년월일', name: 'birthday', width: 100, align: "center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '핸드폰', name: 'cellular', width: 100, align: "center", sortable: true},
          {header: '우편번호', name: 'zipcd', width:90, align:"center", sortable: true},
          {header: '주소 1', name: 'address1', width:300, sortable: true},
          {header: '주소 2', name: 'address2', width:300, sortable: true},
          {header: '직장명', name: 'companyNm', width:150, sortable: true},
          {header: '부서', name: 'partNm', width:150, sortable: true},
          {header: '직위', name: 'levelNm', width:150, sortable: true},
        ];
      this.gridProps['options'].bodyHeight = 410;
      //this.gridProps['columnOptions'].frozenCount = 4;
    },

    downloadExcel() {
      if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '라벨출력';
      kuaaApi.requestFileDownload(
          URL_CONST.LABEL_EXCEL_DOWNLOAD,
          this.query,
          '라벨출력.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"라벨 출력 조회");
      }
    },

    /**
     * 지부/분회 검색 모달 검색 결과에서 항목 선택
     * @param item
     */
    onClickModalBranch(item) {
      this.searchedBranchName = item.branchNm;
      this.query.branchId = item.branchId;
    },
  }
}
</script>

<style scoped>

</style>